###
Page status icons in survey editor.
###

BranchingRule = require('sma.fs/surveys/offline/logic.coffee').BranchingRule
AdvancedBranching = require('sma.fs/surveys/editor/branching.coffee')

class PageStatus extends Backbone.View
	translatables:
		looped: gettext('This page is looped for %(question)s on %(page)s')
		simpleSkipping: gettext('Simple Skipping Information')
		advancedBranching: gettext('Advanced Branching Information')
		noOtherRules: gettext('If no other rules apply')

	loopingTemplate: _.template '''
	<ul>
	<% _.each(survey.looping.getLoopedQuestions(), function(loop) { %>
		<li><%= interpolate(translatables.looped, {question: loop.field.getIdentifier(), page: survey.pages[loop.page].label.display()}) %></li>
	<% }) %>
	</ul>
	'''

	branchingTemplate: _.template '''
	<% if (hasSimpleSkipping()) { %>
		<h4><%= translatables.simpleSkipping %></h4>
		<ul>
		<% _.each(simpleSkipping(), function(rule) { %>
			<li><%= rule %></li>
		<% }) %>
		</ul>
	<% } %>
	<% if (hasAdvancedBranching()) { %>
		<h4><%= translatables.advancedBranching %></h4>
		<ul>
		<% _.each(advancedBranching(), function(rule) { %>
			<li><%= rule %></li>
		<% }) %>
		</ul>
	<% } %>
	'''

	events:
		'click a.show-branching-info': 'showBranchingInfo'
		'click a.show-looping-info': 'showLoopingInfo'

	initialize: (config) ->
		_.bindAll this, 'showBranchingInfo', 'showLoopingInfo'

		@survey = config.survey

	render: ->
		@$el.empty()

		# if @hasSimpleSkipping() or @hasAdvancedBranching()
		# 	@$el.append '<a href="#" class="icon icon-only icon-logic show-branching-info">' + gettext('Branching Info') + '</a> '

		# if @hasLooping()
		# 	@$el.append '<a href="#" class="icon icon-only icon-looping show-looping-info">' + gettext('Branching Info') + '</a>'

		return @$el

	# Shows the tooltip for the page status icons. We set data-tooltip on the icon itself so
	# that clicking the icon again will check for a shown tooltip and hide it (instead of hide
	# + show)
	showTooltip: (e, contents) ->
		e.preventDefault()

		target = $(e.target)

		info = target.data 'tooltip'

		# hide the previously shown tooltip
		if info
			target.data 'tooltip', null
			info.remove()
			return

		info = $('<div class="tooltip tooltip-bottom info-tooltip"/>').html contents

		target.data 'tooltip', info

		info.appendTo('body').position
			my: 'center top'
			at: 'center bottom'
			of: target
			offset: '-4 9'
			collision: 'none none'

		setTimeout (-> $('body').one 'mousedown keydown', (e) ->
			# prevent double-trigger of click event
			if $(e.target).is(target)
				return

			target.data 'tooltip', null
			info.remove()), 0

	showBranchingInfo: (e) ->
		@showTooltip e, @branchingTemplate this

	showLoopingInfo: (e) ->
		@showTooltip e, @loopingTemplate this

	hasLooping: ->
		@survey.currentPage.isLooped()

	hasSimpleSkipping: ->
		# FIXME: optimize to only serialize for questions that can have
		# simple branching.
		for field in @survey.currentPage.fields
			question = field.serialize()
			if question.children?[0]?.branch?.length?
				return true

		return false

	hasAdvancedBranching: -> (AdvancedBranching.formatRules @survey, @survey.currentPage.branching)?.length

	simpleSkipping: ->
		result = []

		for field in @survey.currentPage.fields
			question = field.serialize()

			if question.children?[0]?.branch?
				rules = BranchingRule::parseSimple(question, question.children[0].branch)

				for rule in rules
					if rule.validate(@survey.formatInfo())
						result.push rule.format(@survey.formatInfo())

		return result

	advancedBranching: -> AdvancedBranching.formatRules @survey, @survey.currentPage.branching

module.exports = PageStatus;
